import { defaultStyles } from 'library';
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    container: {
        display: 'table',
        width: '100%',
        tableLayout: 'fixed',
        verticalAlign: 'middle'
    },
    col: {
        display: 'table-cell',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    label: {
        //color: defaultStyles.darkerGrey,
        lineHeight: '18px',
        fontWeight: 'normal',
    },
    bold: {
        fontWeight: 'bold',
    },
    switch: {
        width: '50px',
    },
    input: {
        width: 0,
        height: 0,
        visibility: 'hidden',
        position: 'absolute',
    },
    switchLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        width: '50px',
        height: '32px',
        background: defaultStyles.greyText,
        borderRadius: '50px',
        position: 'relative',
    },
    switchButton: {
        position: 'absolute',
        top: '3px',
        left: '3px',
        width: '26px',
        height: '26px',
        borderRadius: '26px',
        transition: '0.2s',
        background: defaultStyles.white,
        boxShadow: '0 0 2px 0 rgba(10, 10, 10, 0.29)',
    },
    active: {
        left: 'calc(100% - 3px)',
        transform: 'translateX(-100%)',
    }
});

export default styles;
